import { IMilestoneTemplate } from "@/interfaces";

export const clearTargetDatePrepopulationSource = (
  updatedMilestoneId: string,
  milestoneTemplates: IMilestoneTemplate[]
): IMilestoneTemplate[] => {
  const updatedMilestone = milestoneTemplates.find(
    ({ id }) => id === updatedMilestoneId
  );

  if (!updatedMilestone) return milestoneTemplates;

  return milestoneTemplates.map((milestoneTemplate) => {
    const { id, defaultFor, targetDatePrepopulationSource } = milestoneTemplate;

    const isDuplicateDefaultForValue = updatedMilestone.defaultFor?.some(
      (value) => defaultFor?.includes(value)
    );
    const isUniqueSource =
      targetDatePrepopulationSource ===
      updatedMilestone.targetDatePrepopulationSource;
    const isNotUpdatedMilestone = id !== updatedMilestoneId;
    const hasDefaultForValues = !!defaultFor?.length;

    const shouldClear =
      isDuplicateDefaultForValue &&
      isNotUpdatedMilestone &&
      isUniqueSource &&
      hasDefaultForValues;

    if (shouldClear) {
      milestoneTemplate.targetDatePrepopulationSource = "";
    }

    return milestoneTemplate;
  });
};
